import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { LocalStorageService } from 'angular-2-local-storage';
import { environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class CacheService {
    public cookieService: CookieService = new CookieService(document);
    constructor(private _localStorageService: LocalStorageService) { }

    /**
     * get the value from storage for pair of key
     * @param  {string} cacheKey
     */
    public get(cacheKey: string): any {
        if (cacheKey) {
            return this._localStorageService.get(cacheKey);
        }
    }


    /**
     * save the value into storage with pair of key
     * @param  {string} cacheKey
     */
    public set(cacheKey: string, cacheValue: any): void {
        if (cacheKey && cacheValue) {
            this._localStorageService.set(cacheKey, cacheValue);
        }
    }

    /**
     * remove the value form storage
     * @param  {string} cacheKey
     */
    public remove(cacheKey: string): void {
        if (cacheKey) {
            this._localStorageService.remove(cacheKey);
        }
    }

    /**
     * remove the value form storage
     * @param  {string} cacheKey
     */
    public removeAll(isValid: boolean): void {
        if (isValid) {
            this._localStorageService.clearAll();
        }
    }

     /**
     * @returns any
     */
    public getSessionValue(cacheKey: string): any {
        if (cacheKey) {
            return sessionStorage.getItem(cacheKey);
        }
    }

    /**
     * @returns any
     */
    public setSessionValue(cacheKey: string, cacheValue: any): any {
        if (cacheKey) {
            return sessionStorage.setItem(cacheKey, cacheValue);
        }
    }

    /**
     * @returns any
     */
    public removeSessionValue(cacheKey: string): void {
        if (cacheKey) {
            sessionStorage.removeItem(cacheKey);
        }
    }

    /**
* get the value from cookie storage for pair of key
* @param  {string} cacheKey
*/
    public getCookieValue(cacheKey: string): any {
        if (cacheKey) {
            return this.cookieService.get(cacheKey);
        }
    }


    /**
     * save the value into cookie storage with pair of key
     * @param  {string} cacheKey
     */
    public setCookieValue(cacheKey: string, cacheValue: any): void {
        if (cacheKey && cacheValue) {
            const cookieExpiryDate: Date = new Date((new Date()).valueOf() + 1000 * 60 * 60 * 24 * environment.cookieExpiryDays);
            this.cookieService.set(cacheKey, cacheValue, cookieExpiryDate, environment.cookiePath, environment.cookieDomain);
        }
    }

    /**
     * remove the value from the cookie
     * @param  {string} cacheKey
     */
    public removeCookieValue(cacheKey: string): void {
        if (cacheKey) {
            this.cookieService.delete(cacheKey, environment.cookiePath, environment.cookieDomain);
        }
    }

}
